// import SupportGif from "../../assets/images/support.gif"
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import React, { useState } from "react";
import Startchallengequestion from '../scquestion';
import { createstartchallenge } from "../../actions/workshop";

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useUserTokenSelector } from "store/reducers";

const StartChallenge = () => {
    const userToken = useUserTokenSelector();

    const [optionchange, setStateforoptionchange] = useState({
        optionchange: "",
        dailygoal: "",
        challengedescription: "",
    });
    const [datestartvalue, setValue] = useState('');
    const [dateendvalue, setValue1] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target
        console.log("one", name)
        console.log("onee", value)


        setStateforoptionchange(prevState => ({
            ...prevState,
            [name]: value
        }))

    }

    function handleChangee(val) {
        console.log("valuee", val['$d'])

        setValue(val['$d'])

    }
    function handleChangee1(val) {
        console.log("valuee", val['$d'])

        setValue1(val['$d'])

    }






    async function startchallenge() {
        // let startdate = new Date(optionchange.startdate);
        // let enddate = new Date(optionchange.enddate);
        let datestart = new Date(datestartvalue).toISOString();
        let dateend = new Date(dateendvalue).toISOString();

        const data = {
            challengename: optionchange.optionchange,
            challengedescription: optionchange.challengedescription,
            startdate: datestart,
            enddate: dateend,
            dailygoal: optionchange.dailygoal,
            // token: userToken
        };

        try {
            const res = await createstartchallenge(userToken, data);
            console.log("response", res)
            alert("Successfully Created the Challenge", "success");
        } catch (error) {
            alert("Fields Required");
        }

    }
    return (
        <section id="select_filed">

            <select onChange={handleChange} required name="optionchange" class="form-select" aria-label="Default select example">
                <option value="" selected>Select Challenge to launch</option>
                <option value="stepchallenge">Step Challenge</option>
                <option value="runningchallenge">Running Challenge</option>
                <option value="meditationchallenge">Meditation Challenge</option>
                <option value="yogachallenge">Yoga Challenge</option>
            </select>

            <br />
            <div class="goal_secc">
                <h5>Your Challenge Description<p><span>
                    <input type="text" class="form-control" name="challengedescription" required onChange={handleChange} />
                </span></p></h5>
            </div>

            <div class="box">
                <h5><img src="profile.jpg" alt="" />Select a Challenge
                    <span>Start Your Challenge Now</span>
                </h5>
                <p>This is the description . Lorem ipsum dolar sit met .Select challenge from the dropdown above to start your wellbeing challenge</p>

            </div>




            <div class="date_sec">
                <div class="form-group">
                    <label>Start Date</label>
                    {/* <input type="date" required onChange={handleChange} name="startdate"/> */}

                    <LocalizationProvider id="start-time-date"
                        name="start-time-date" dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <DateTimePicker id="start-time-date" name="startdate" value="" onChange={(newValue) => handleChangee(newValue)} />
                        </DemoContainer>
                    </LocalizationProvider>



                </div>

                <div class="form-group">
                    <label>End Date</label>
                    {/* <input type="date" required onChange={handleChange} name="enddate"/> */}

                    <LocalizationProvider id="start-time-date"
                        name="start-time-date" dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <DateTimePicker id="start-time-date" name="enddate" value="" onChange={(newValue1) => handleChangee1(newValue1)} />
                        </DemoContainer>
                    </LocalizationProvider>

                </div>

            </div>

            <div class="goal_sec">
                <h3><img src="profile.jpg" alt="" />Your Challenge <p>Daily goal: <span><input type="number" name="dailygoal" required onChange={handleChange} /></span></p></h3>
            </div>


            {/* question start */}
            {/* {optionchange.optionchange ? <Startchallengequestion></Startchallengequestion> : ""} */}


            {/* question end */}


            <a onClick={startchallenge} type="submit" class="btn">Start Challenge</a>

        </section>
    );
};

export default StartChallenge;
